import { Hub as Hub$1, Scope as Scope$1, getCurrentHub as getCurrentHub$1, addGlobalEventProcessor as addGlobalEventProcessor$1, getHubFromCarrier as getHubFromCarrier$1, getMainCarrier as getMainCarrier$1, makeMain as makeMain$1, setHubOnCarrier as setHubOnCarrier$1, SessionFlusher as SessionFlusher$1, closeSession as closeSession$1, makeSession as makeSession$1, updateSession as updateSession$1, addBreadcrumb as addBreadcrumb$1, captureException as captureException$1, captureEvent as captureEvent$1, captureMessage as captureMessage$1, configureScope as configureScope$1, startTransaction as startTransaction$1, setContext as setContext$1, setExtra as setExtra$1, setExtras as setExtras$1, setTag as setTag$1, setTags as setTags$1, setUser as setUser$1, withScope as withScope$1 } from '@sentry/core';

;

/**
 * @deprecated This export has moved to @sentry/core. The @sentry/hub package will be removed in v8
 */
class Hub extends Hub$1 {}

/**
 * @deprecated This export has moved to @sentry/core. The @sentry/hub package will be removed in v8
 */
class Scope extends Scope$1 {}

/**
 * @deprecated This export has moved to @sentry/core. The @sentry/hub package will be removed in v8.
 */
const getCurrentHub = getCurrentHub$1;

/**
 * @deprecated This export has moved to @sentry/core. The @sentry/hub package will be removed in v8.
 */
const addGlobalEventProcessor = addGlobalEventProcessor$1;

/**
 * @deprecated This export has moved to @sentry/core. The @sentry/hub package will be removed in v8.
 */
const getHubFromCarrier = getHubFromCarrier$1;

/**
 * @deprecated This export has moved to @sentry/core. The @sentry/hub package will be removed in v8.
 */
const getMainCarrier = getMainCarrier$1;

/**
 * @deprecated This export has moved to @sentry/core. The @sentry/hub package will be removed in v8.
 */
const makeMain = makeMain$1;

/**
 * @deprecated This export has moved to @sentry/core. The @sentry/hub package will be removed in v8.
 */
const setHubOnCarrier = setHubOnCarrier$1;

/**
 * @deprecated This export has moved to @sentry/core. The @sentry/hub package will be removed in v8.
 */
const SessionFlusher = SessionFlusher$1;

/**
 * @deprecated This export has moved to @sentry/core. The @sentry/hub package will be removed in v8.
 */
const closeSession = closeSession$1;

/**
 * @deprecated This export has moved to @sentry/core. The @sentry/hub package will be removed in v8.
 */
const makeSession = makeSession$1;

/**
 * @deprecated This export has moved to @sentry/core. The @sentry/hub package will be removed in v8.
 */
const updateSession = updateSession$1;

/**
 * @deprecated This export has moved to @sentry/core. The @sentry/hub package will be removed in v8.
 */
const addBreadcrumb = addBreadcrumb$1;

/**
 * @deprecated This export has moved to @sentry/core. The @sentry/hub package will be removed in v8.
 */
const captureException = captureException$1;

/**
 * @deprecated This export has moved to @sentry/core. The @sentry/hub package will be removed in v8.
 */
const captureEvent = captureEvent$1;

/**
 * @deprecated This export has moved to @sentry/core. The @sentry/hub package will be removed in v8.
 */
const captureMessage = captureMessage$1;

/**
 * @deprecated This export has moved to @sentry/core. The @sentry/hub package will be removed in v8.
 */
const configureScope = configureScope$1;

/**
 * @deprecated This export has moved to @sentry/core. The @sentry/hub package will be removed in v8.
 */
const startTransaction = startTransaction$1;

/**
 * @deprecated This export has moved to @sentry/core. The @sentry/hub package will be removed in v8.
 */
const setContext = setContext$1;

/**
 * @deprecated This export has moved to @sentry/core. The @sentry/hub package will be removed in v8.
 */
const setExtra = setExtra$1;

/**
 * @deprecated This export has moved to @sentry/core. The @sentry/hub package will be removed in v8.
 */
const setExtras = setExtras$1;

/**
 * @deprecated This export has moved to @sentry/core. The @sentry/hub package will be removed in v8.
 */
const setTag = setTag$1;

/**
 * @deprecated This export has moved to @sentry/core. The @sentry/hub package will be removed in v8.
 */
const setTags = setTags$1;

/**
 * @deprecated This export has moved to @sentry/core. The @sentry/hub package will be removed in v8.
 */
const setUser = setUser$1;

/**
 * @deprecated This export has moved to @sentry/core. The @sentry/hub package will be removed in v8.
 */
const withScope = withScope$1;

export { Hub, Scope, SessionFlusher, addBreadcrumb, addGlobalEventProcessor, captureEvent, captureException, captureMessage, closeSession, configureScope, getCurrentHub, getHubFromCarrier, getMainCarrier, makeMain, makeSession, setContext, setExtra, setExtras, setHubOnCarrier, setTag, setTags, setUser, startTransaction, updateSession, withScope };
//# sourceMappingURL=index.js.map
